<template>
  <aside class="where-to-buy">
    <header class="header-question">
      <p>
        Где купить в
        <select
          v-model="activeCity"
          title="Выберите свой город"
        >
          <option
            v-for="city in cities"
            v-bind:key="city"
          >{{ city }}</option>
          <option disabled selected>{{ defaultCity }}</option>
        </select>
        <br>
        {{ categoryName.toLowerCase() }} от ювелирной фирмы «Стиль»?
      </p>
    </header>
    <transition name="fade">
      <div
        class="shop-in-your-city-info"
        v-if="activeCity !== defaultCity"
      >
        <div
          class="sorry-answer-wrapper"
          v-if="activeCity !== cities[0]"
        >
          <p class="sorry-answer">
            На данный момент купить наши украшения можно только в Бресте.<br>
            К сожалению, доставка ювелирных изделий запрещена законом.<br>
            Но мы с радостью ждем Вас или Ваших знакомых в Бресте!
          </p>
        </div>
        <basic-contacts v-else></basic-contacts>
      </div>
    </transition>
  </aside>
</template>

<script>
import BasicContacts from './utils/BasicContacts'
import TransitionHeightExpand from '@/components/utils/TransitionHeightExpand'

export default {
  name: 'CatalogCategoryWhereToBuy',
  components: {BasicContacts, TransitionHeightExpand},
  props: ['category-name'],
  data: function () {
    return {
      cities: ['Бресте', 'Минске', 'Гомеле', 'Витебске', 'Могилеве', 'Гродно'],
      defaultCity: 'вашем городе',
      activeCity: 'вашем городе'
    }
  },
  methods: {
    changeShopInYourCityInfo: function (event) {
      console.log(event.target.value)
    }
  }
}
</script>

<style scoped lang="scss">
  @mixin where-to-buy-fonts-mixin {
    font-family: "Baskerville Italic", "Gotham Pro Regular", $font-stack;
    .wf-baskervilleitalic-n4-active & {
      @include media (">tablet") { font-size: 17px; }
      @include media ("<=tablet") { font-size: 20px; }
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  .where-to-buy {
    @media only print { display: none; }
  }
  .header-question {
    padding: 0 1em;
    @include where-to-buy-fonts-mixin;
    select {
      background-color: $default-background-color;
      border: 0;
      color: $default-text-color;
      @include where-to-buy-fonts-mixin;
    }
    p {
      line-height: normal;
      margin-bottom: 0;
    }
  }
  .shop-in-your-city-info {
    padding: 1em 0;
    font-family: "Gotham Pro Regular", $font-stack;

    & > .sorry-answer-wrapper {
      @include centered-block-width($big-tablet: 80%, $small-tablet: 90%);
      color: $default-heading-color;
      & > .sorry-answer {
        padding: 1em;
        margin-bottom: 0;
        display: inline-block;
        border-top: 1px solid $default-link-color;
        border-bottom: 1px solid $default-link-color;
        & > p {
          margin-bottom: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/CatalogCategoryWhereToBuy.vue